module.exports = __webpack_public_path__ + "static/img/mini-logo.517a734.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/wenxing/assets/images/mini-logo.jpg
// module id = zusS
// module chunks = 70